export default function FileSummary({ files }) {
  const counts = {
    pending: files.filter((f) => f.status === "pending").length,
    success: files.filter((f) => f.status === "success").length,
    error: files.filter((f) => f.status === "error").length,
  };

  return (
    <section className="file-summary">
      <h2>{files.length} selected</h2>
      <div className="badges">
        {!!counts.success && (
          <span className="badge ok">{counts.success} done</span>
        )}
        {!!counts.error && (
          <span className="badge err">{counts.error} failed</span>
        )}
      </div>
    </section>
  );
}